import { DEFAULT_FONTS } from './Page.const'

export const getFontUrl = (fontName, customFont) => {
	if (!fontName) return ''
	if (customFont?.name && customFont.name === fontName) {
		return customFont.url
	}
	return DEFAULT_FONTS[fontName]
		? `${import.meta.env.VITE_ASSET_URL}/fonts/scorecard-fonts/${encodeURIComponent(fontName)}/index.css`
		: `${import.meta.env.VITE_FONTS_SOURCE_URL}?family=${encodeURIComponent(fontName)}:400,500,700&display=swap`
}

export const loadFont = (elementId, fontName, customFont) => {
	if (!fontName) return
	let $element = document.getElementById(elementId)
	if (!$element) {
		$element = document.createElement('link')
		$element.setAttribute('id', elementId)
		$element.setAttribute('rel', 'stylesheet')
		document.head.appendChild($element)
	}

	$element.setAttribute('href', getFontUrl(fontName, customFont))
}
